import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'alert-custom',
    templateUrl: './alert-custom.component.html',
    styleUrls: ['./alert-custom.component.scss'],
    imports: [DialogModule, Button, TranslatePipe]
})
export class AlertCustomComponent implements OnInit {

	@Output() onCloseModal = new EventEmitter();

	@Input() title: string;
	@Input() msg: string;
	@Input() elId: string;

	displayModal: boolean;

	constructor(
		private renderer: Renderer2) {
		this.renderer = renderer;
	}

	ngOnInit() {
		this.displayModal = true;
	}

	modalParams(title: string, msg: string, elId?: string) {
		this.title = title;
		this.msg = msg;
		this.elId = elId;
	}

	closeModal() {
		this.displayModal = false;
		if (this.elId) {
			this.renderer.selectRootElement(`#${this.elId}`).focus();
		}
		this.onCloseModal.emit(this.elId);
	}
}

